import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Radio, Icon, Image, Grid, Popup } from 'semantic-ui-react';

import * as ProductionReportSetupActions from '../state/reports/actions';
import * as ProductionReportSetupSelectors from '../state/selectors';
import { Templates } from '../helpers/Constants'

import simpleTemplatePdf from '../../../documents/SimpleTemplate.pdf';
import detailedTemplatePdf from '../../../documents/DetailedTemplate.pdf';
import complexTemplatePdf from '../../../documents/ComplexTemplate.pdf';

class SelectTemplatePage extends Component {
    selectTemplate = (evt, { value }) => {
        const { setSelectedTemplate } = this.props;        

        setSelectedTemplate(value);
    };

    render() {
        const { selectedTemplate } = this.props;

        return (
            <Grid columns={3}>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Radio label='Simple Template' name='templateGroup' value={Templates.Simple} onChange={this.selectTemplate} checked={selectedTemplate === Templates.Simple}/>
                    </Grid.Column>
                    <Grid.Column width={1}>
                        <Popup trigger={
                                <a href={simpleTemplatePdf} target='_blank'>
                                    <Icon name='eye' style={{ color: '#df5a17', }} />
                                </a>
                            } position="top center">
                            View Template
                        </Popup>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={3}>
                        <Image src='SimpleTemplate.png' size='small'/>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row></Grid.Row>

                <Grid.Row>
                    <Grid.Column width={3}>
                        <Radio label='Detailed Template' name='templateGroup' value={Templates.Detailed} onChange={this.selectTemplate} checked={selectedTemplate === Templates.Detailed}/>
                    </Grid.Column>
                    <Grid.Column width={1}>
                        <Popup trigger={
                                <a href={detailedTemplatePdf} target='_blank'>
                                    <Icon name='eye' style={{ color: '#df5a17', }} />
                                </a>
                            } position="top center">
                            View Template
                        </Popup>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={3}>
                        <Image src='DetailedTemplate.png' size='small' />
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row></Grid.Row>

                <Grid.Row>
                    <Grid.Column width={3}>
                        <Radio label='Complex Template' name='templateGroup' value={Templates.Complex} onChange={this.selectTemplate} checked={selectedTemplate === Templates.Complex}/>
                    </Grid.Column>
                    <Grid.Column width={1}>
                        <Popup trigger={
                                <a href={complexTemplatePdf} target='_blank'>
                                    <Icon name='eye' style={{ color: '#df5a17', }} />
                                </a>
                            } position="top center">
                            View Template
                        </Popup>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={3}>
                        <Image src='ComplexTemplate.png' size='small' />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    };
}

const mapStateToProps = state => ({
    page: ProductionReportSetupSelectors.getPage(state),    
    selectedTemplate: ProductionReportSetupSelectors.getTemplate(state), 
});
  
const mapDispatchToProps = {
    setSelectedTemplate: ProductionReportSetupActions.setSelectedTemplate,
};

SelectTemplatePage = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectTemplatePage);

export { SelectTemplatePage };


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/SelectTemplatePage.js